// Инициализация форм документа.

import Lightbox from '~/app/elements/Lightbox';
import {parseSearchString} from '~/utils/convertation/parseSearchString';
import {getCookies} from '~/utils/getters/getCookies';
import {initCalltouch} from './initCalltouch';

declare global {
	interface Window {
		ym: any
	}
}

/**
 * Класс, назначаемый после успешной отправки формы.
 */
const CLASS_SUCCESS = 'success';
/**
 * Класс, назначаемый на время отправки формы.
 */
const CLASS_PROGRESS = 'progress';

/**
 * Инициализация форм документа.
 */
function main(): void
{
	for ( let i = 0, n = document.forms.length; i < n; i++ )
	{
		initForm( document.forms.item( i ) );
	}
}

/**
 * Инициализация формы.
 */
function initForm( form: HTMLFormElement ): void
{
	if ( form.dataset.ajax !== 'true' )
	{
		return;
	}
	
	const btnSubmit = form.querySelector( 'button[type="submit"]' ) as HTMLButtonElement;
	
	if ( !btnSubmit )
	{
		return;
	}
	
	const btnOk = form.querySelector( 'div.success button' ) as HTMLButtonElement;
	const lightbox = Lightbox.instance;
	
	if ( btnOk )
	{
		btnOk.addEventListener(
			'click',
			(): void =>
			{
				lightbox.close();
				form.classList.remove( CLASS_SUCCESS );
			},
		);
	}
	
	form.addEventListener(
		'submit',
		( event: Event ) =>
		{
			event.preventDefault();
			
			const xhr = new XMLHttpRequest();
			const data = new FormData( form );
			const bitrixData = form.dataset.bitrix;
			const nameInput = form.querySelector( 'input[name="name"]' ) as HTMLInputElement;
			const phoneInput = form.querySelector( 'input[name="tel"]' ) as HTMLInputElement;
			const emailInput = form.querySelector( 'input[name="email"]' ) as HTMLInputElement;
			const contributionInput = form.querySelector( 'input[name="payment"]' ) as HTMLInputElement;
			let bitrixJSON: any = null;

			if ( bitrixData && phoneInput )
			{
				const cookies: any = getCookies();
				const utmParameters: any = parseSearchString( location.search );
				
				bitrixJSON = JSON.parse( bitrixData );
				bitrixJSON['name'] = nameInput ? nameInput.value : '';
				bitrixJSON['email'] = emailInput ? emailInput.value : '';
				bitrixJSON['hypothec_contribution'] = contributionInput ? contributionInput.value : '';
				bitrixJSON['time'] = ( new Date ).toLocaleString();
				bitrixJSON['site'] = window.location.href;
				bitrixJSON['ga'] = cookies['_ga'] ? `${cookies['_ga'].split( '.' )[2]}.${cookies['_ga'].split( '.' )[3]}` : '';
				bitrixJSON['ym_uid'] = cookies['_ym_uid'] ? cookies['_ym_uid'] : '';
				bitrixJSON['utm_source'] = utmParameters['utm_source'] ? utmParameters['utm_source'] : '';
				bitrixJSON['utm_medium'] = utmParameters['utm_medium'] ? utmParameters['utm_medium'] : '';
				bitrixJSON['utm_term'] = utmParameters['utm_term'] ? utmParameters['utm_term'] : '';
				bitrixJSON['utm_content'] = utmParameters['utm_content'] ? utmParameters['utm_content'] : '';
				bitrixJSON['utm_campaign'] = utmParameters['utm_campaign'] ? utmParameters['utm_campaign'] : '';

				
				let phone = phoneInput.value.replace( /\D/g, '' );

				if ( phone[0] === '8' )
				{
					bitrixJSON['phone'] = `+7${phone.slice( 1 )}`;
				}
				else if ( phone[0] === '7' )
				{
					bitrixJSON['phone'] = `+${phone}`;
				}
				else
				{
					bitrixJSON['phone'] = `+7${phone}`;
				}

				if ( bitrixJSON['phone'].length < 12 )
				{
					bitrixJSON = null;
				}
			}
			
			data.append( 'pageUrl', window.location.href );

			if ( sessionStorage.getItem( 'UTMTags' ) )
			{
				const UTMTags = JSON.parse( sessionStorage.getItem( 'UTMTags' )! );
				const utmParameters2 = Object.keys( UTMTags ).map( ( tag ) => `${tag}=${UTMTags[tag]}` ).join( ', ' );

				if ( utmParameters2 )
				{
					data.append( 'utmParameters', utmParameters2 );
				}
			}
			
			btnSubmit.blur();

			initCalltouch( form );
			
			xhr.onload = (): void =>
			{
				form.classList.remove( CLASS_PROGRESS );
				
				if ( xhr.status < 400 )
				{
					try
					{
						const response = JSON.parse( xhr.responseText );
						
						if ( response.success )
						{
							form.classList.add( CLASS_SUCCESS );

							if ( bitrixJSON )
							{
								bitrixJSON['USER_IP'] = response.ip;

								fetch( 'https://ep.morekit.io/70734aaf72161ca60d88ec522a5ef7a3', {
									method: 'POST',
									mode: 'cors',
									cache: 'no-cache',
									credentials: 'same-origin',
									body: JSON.stringify( bitrixJSON ),
									headers: {
										'Content-Type': 'application/json',
									},
									referrerPolicy: 'no-referrer',
								} )
									.then( () => {
										console.log( 'success' );
									} )
									.catch( ( error ) => {
										console.log( error );
									} );
							}

							const _rutarget = window._rutarget || [];

							_rutarget.push({
								'event': 'thankYou',
								'conv_id': 'lead'
							});
							
							if ( form.dataset.criteo )
							{
								// tslint:disable-next-line:no-non-null-assertion
								sendCriteo( form.dataset.criteo!, response.uid );
							}

							if ( form.dataset.ymGoal )
							{
								const ym = window.ym || [];
								const goal = form.dataset.ymGoal;
	
								if ( !ym )
								{
									return;
								}
								
								ym( 85715770,'reachGoal',goal );
							}
						}
						else if ( response.error )
						{
							console.error( response.error );
						}
					}
					catch ( _error )
					{
						// Ну и ладно, не очень и хотелось
					}
				}
			};
			
			form.classList.add( CLASS_PROGRESS );
			
			xhr.open( 'POST'/*form.method*/, form.action );
			xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
			xhr.send( data );
			
			if ( form.dataset.tracking )
			{
				try
				{
					// tslint:disable-next-line:no-non-null-assertion
					const trackingData = JSON.parse( form.dataset.tracking! );
					
					if ( Array.isArray( trackingData ) )
					{
						sendTracking( trackingData );
					}
				}
				catch ( error )
				{
					console.error( error );
				}
			}
		},
	);
}

/**
 * Отправляет данные отслеживания.
 * 
 * @param data Данные события.
 */
function sendTracking( data: string[] ): void
{
	const ga = (window as any).ga;
	
	if ( !ga )
	{
		return;
	}
	
	ga.apply(
		null,
		[
			ga.getAll()[0].get( 'name' ) + '.send',
			...data,
		],
	);
}

/**
 * Отправляет данные отслеживания Criteo.
 * 
 * @param json JSON-кодированный объект события Criteo.
 * @param uid Уникальный ID события.
 */
function sendCriteo( json: string, uid?: string ): void
{
	const criteoTrackers: any[] = (window as any).criteo_q || [];
	
	try
	{
		const data = JSON.parse( json );
		
		if ( uid && ( 'id' in data ) )
		{
			if ( !data.id )
			{
				data.id = uid;
			}
			else
			{
				data.id = String( data.id ).replace( '##ID##', uid );
			}
		}
		
		criteoTrackers.push( data );
	}
	catch ( error )
	{
		console.error( error );
	}
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/Forms/index.ts